module.exports = __webpack_public_path__ + "img/好友分隔.52b432ae.svg";